<template lang="pug">
form.v-form.form(v-if="data" @submit.prevent="handlerSubmit({closePanel: true})" :id="form?.id")
	v-loader(:loading="loading")
	img.form__icon(v-if="data.icon" :src="data.icon")
	.form__title(v-if="data.title") {{data.title}}
	.form__fields(v-if="data.fields")
		v-field.form__field(v-for="field in data.fields"
				:field="field"
				v-model="field.value"
				@update:model-value="fieldChanged"
				@update-inner-field="handlerUpdateInnerField"
				@fileinput="fileInput(field, $event)"
				@fileremove="fileRemove(field, $event)"
				:style="{'width': field.width}"
			)
	.form__actions(v-if="data.buttons")
		button.btn.form__action(v-if="data.buttons.submit" type="submit" :class="data.buttons.submit.className") {{data.buttons.submit.text}}
		button.btn.form__action(v-if="data.buttons.reject" type="button" @click="handlerSubmit({action: data.buttons.reject.action})" :class="data.buttons.reject.className") {{data.buttons.reject.text}}
		v-action.btn.form__action(v-if="data.buttons.clear" :action="data.buttons.clear" @click="handlerClear")
			template(#icon)
				v-svg-icon.btn__icon(v-if="data.buttons.clear.icon" :icon="data.buttons.clear.icon")
	.form__agreement(v-if="data.agreement")
		v-field-checkbox(:field="data.agreement" v-model="data.agreement.value" @update:model-value="fieldChanged")
		.field__error(v-if="data.agreement?.error") {{data.agreement.error}}
	teleport(to="body")
		v-modal(v-if="message && !hideMessage" :data="{closeText: data.closeText}" @close="() => message = null")
			v-form-message(:message="message" @action="() => message = null")

</template>

<script>

import sourceMixin from './mixins/v-mixin-source.vue';
import isMobMixin from "./mixins/v-mixin-is-mob.vue";
import controller from "../scripts/controller/controller.js";
import {nextTick} from "vue";

export default {

	mixins: [
		sourceMixin,
		isMobMixin
	],

	emits: [
		'message',
		'response'
	],

	props: {
		form: {
			type: Object,
			default: null
		},

		action: {
			type: String,
			default: null
		},

		hideMessage: {
			type: Boolean,
			default: null
		}
	},

	watch: {
		form(state, oldState) {
			this.data = state;
			if (state.bxajaxid) {
				this.localBxajaxid = this.form.bxajaxid;
			}
			if (state.view !== oldState.view) {
				this.handlerSubmit({view: state.view});
			}
		},

		action(state) {
			if (state) {
				this.handlerAction(state);
			}
		},

		data(newVal, oldVal) {
			if (newVal && !oldVal) {
				this.checkScrollToSelfByUrl();
			}
		}
	},

	data() {
		return {
			data: null,
			loading: false,
			localFormData: new FormData(),
			message: null
		}
	},

	mounted() {
		if (this.form) {
			this.data = this.form;
			if (this.form.bxajaxid) {
				this.localBxajaxid = this.form.bxajaxid;
			}
		}
		controller.events.on('setFormFieldValue', field => {
			this.handlerScrollToForm({field});
		});
		document.addEventListener('click', this.handlerClickListener);
	},

	unmounted() {
		document.removeEventListener('click', this.handlerClickListener)
	},

	methods: {
		proxyFieldName(id) {
			return `state[form][${id}]`;
		},

		proxyParentFieldName(id, parentId) {
			return `state[form][${parentId}][${id}]`;
		},

		dataSet(data, options = {}) {
			this.data = data;
			this.loading = false;
			if (data.bxajaxid) {
				this.localBxajaxid = data.bxajaxid;
			}
			if (data.message) {
				this.message = data.message;
				this.$emit('message', data, options);
			}
			if (options.emit) {
				this.$emit('response', data, options);
			}
			if (window.location.pathname.indexOf('/local/') < 0 && options.updateUrl) {
				window.history.replaceState(null, null, data.remote);
			}
		},

		requestDataLoad(dataSetOptions) {
			if (this.loading) {
				return;
			}
			this.loading = true;
			if (this.data.page) {
				this.localFormData.set('page[offset]', this.data.page.offset);
				this.localFormData.set('page[limit]', this.data.page.limit);
				this.localFormData.set('page[count]', this.data.page.count);
			}
			this.dataLoad({
				url: this.data.remote,
				delay: false,
				method: 'POST',
				data: this.localFormData,
			}, {...dataSetOptions, emit: true, updateUrl: true});
		},

		fieldChanged(value, field) {
			if (this.data.page) {
				this.data.page.offset = 0
			}
			if (field.autosubmit) {
				this.handlerSubmit({action: 'autosubmit', closePanel: !this.isTablet});
			}
		},

		handlerUpdateInnerField(value, field) {

			if(field.alternativeFieldId) {
				try {
					let selfIndex = this.data.fields.findIndex(item => item.id === field.parent.id);
					let altFieldIndex = this.data.fields.findIndex(item => item.id === field.alternativeFieldId);

					this.data.fields[selfIndex].required = value ? true : this.data.fields[selfIndex].requiredInitial;
					this.data.fields[altFieldIndex].required = value ? this.data.fields[altFieldIndex].requiredInitial : true

					this.data.fields[selfIndex].checkbox.value = value;
					this.data.fields[altFieldIndex].checkbox.value = !value;
				} catch (e) {}
			}
		},

		fileInput(field, e) {
			for (let i = 0; i < e.target.files.length; i++) {
				this.localFormData.append(this.proxyFieldName(field.id) + '[' + e.key + ']', e.target.files[i].path || e.target.files[i]);
			}

			if (field.autosubmit) {
				this.handlerSubmit({action: 'autosubmit'});
			}
		},

		fileRemove(field, e) {
			this.localFormData.delete(this.proxyFieldName(field.id) + '[' + e.key + ']');

			if (field.autosubmit) {
				this.handlerSubmit({action: 'autosubmit'});
			}
		},

		handlerSubmit(options = {}) {
      		if (options.action === 'reject' || options.action === 'clear') {
      		  this.localFormData = new FormData();
      		} else {
				this.data.fields.forEach(field => {
					if (field.type === 'check-list') {
						field.options.forEach(option => this.localFormData.set(this.proxyParentFieldName(option.id, field.id), option.value))
					} else {
						this.localFormData.set(this.proxyFieldName(field.id), field.value);
						if (field.checkbox) {
							this.localFormData.set(this.proxyFieldName(field.checkbox.id), field.checkbox.value);
						}
					}
				});
				if(this.data?.agreement) {
					this.localFormData.set(this.proxyFieldName(this.data.agreement.id), this.data.agreement.value);
				}
			}

			this.localFormData.set('state[action]', options.action || 'submit');
			this.localFormData.set('state[view]', this.data.view);
			this.localFormData.set('bxajaxid', this.bxajaxid);
			this.requestDataLoad(options);
		},

		 handlerScrollToForm(options)  {

			window.scrollTo({top: this.$el.getBoundingClientRect().top + window.pageYOffset - window.innerHeight / 4, behavior: 'smooth'});
			if (options?.field) {
				let field = this.data.fields.find(field => options.field.id === field.id);
				if (field) {
					field.value = options.field.value;
					this.fieldChanged(options.field.value, options.field)
				}
			}
		},

		handlerClickListener(e) {
			if (e.target.closest('.js-scroll-to-form')) {
				e.preventDefault();
				let btn = e.target.closest('.js-scroll-to-form');
				this.handlerScrollToForm({field: btn.dataset.field ? JSON.parse(btn.dataset.field) : null});
			}
		},

		handlerClear() {
			this.handlerSubmit({action: 'clear'});
		},

		handlerAction(action) {
			this.handlerSubmit({action});
		},

		async checkScrollToSelfByUrl(){
			if (window.location.hash && window.location.hash.replace('#','') === this.data?.id) {
				await nextTick();
				setTimeout(this.handlerScrollToForm, 500);
			}
		}
	}
}

</script>
